export default {
    data() {
        return {
            pastedDurations: '',
            pastedDurationsCount: 0,
            showEmptyDurationErrors: false,
            displayedVideoCount: 0,
            videoCountDebounce: null,
        }
    },
    computed: {
        visibleClientParts() {
            const count = this.displayedVideoCount || this.getVideoCount();
            return this.client_parts.slice(0, count);
        }
    },
    methods: {
        getVideoCount() {
            const count = parseInt(this.template && this.template.videos, 10);
            return Number.isFinite(count) && count > 0 ? count : 0;
        },
        createEmptyPart() {
            return {
                duration: '',
                speed: '1.0',
                effect_type: 0,
                effect_values: {x: 0.5, y: 0.5},
                collage_type: 0,
                content_type: 0,
                frame: 0,
                start_time: 0,
                cutout_animation_type: 0,
                cutout_animation_duration: 0,
                cutout_start_time: 0,
                cutout_scale: 0,
                cutout_x: 0.5,
                cutout_y: 0.5,
                cutout_only: 0,
            };
        },
        changeVideoCount(value) {
            const count = parseInt(value, 10);
            if (!Number.isFinite(count) || count < 0) {
                if (this.videoCountDebounce) {
                    clearTimeout(this.videoCountDebounce);
                    this.videoCountDebounce = null;
                }
                return;
            }

            while (this.client_parts.length < count) {
                this.client_parts.push(this.createEmptyPart());
            }

            if (this.videoCountDebounce) {
                clearTimeout(this.videoCountDebounce);
                this.videoCountDebounce = null;
            }

            if (count >= this.displayedVideoCount) {
                this.displayedVideoCount = count;
            } else {
                this.videoCountDebounce = setTimeout(() => {
                    this.displayedVideoCount = this.getVideoCount();
                    this.videoCountDebounce = null;
                }, 600);
            }
        },
        commitVideoCount() {
            if (this.videoCountDebounce) {
                clearTimeout(this.videoCountDebounce);
                this.videoCountDebounce = null;
            }

            const count = this.getVideoCount();
            while (this.client_parts.length < count) {
                this.client_parts.push(this.createEmptyPart());
            }
            this.displayedVideoCount = count;
        },
        setVisiblePartCount(count) {
            if (this.videoCountDebounce) {
                clearTimeout(this.videoCountDebounce);
                this.videoCountDebounce = null;
            }
            this.template.videos = count;
            this.displayedVideoCount = count;
        },
        duplicatePart(index) {
            const count = this.getVideoCount();
            if (index < 0 || index >= count || !this.client_parts[index]) {
                return;
            }

            const visible = this.client_parts.slice(0, count);
            const hidden = this.client_parts.slice(count);
            const copy = JSON.parse(JSON.stringify(visible[index]));
            visible.splice(index + 1, 0, copy);
            this.client_parts = visible.concat(hidden);
            this.setVisiblePartCount(visible.length);
        },
        removePart(index) {
            const count = this.getVideoCount();
            if (index < 0 || index >= count) {
                return;
            }
            if (!confirm("Подтверждение удаления фрагмента " + (parseInt(index, 10) + 1))) {
                return;
            }

            const visible = this.client_parts.slice(0, count);
            const hidden = this.client_parts.slice(count);
            visible.splice(index, 1);
            this.client_parts = visible.concat(hidden);
            this.setVisiblePartCount(visible.length);
        },
        partsForSave() {
            return this.client_parts.slice(0, this.getVideoCount());
        },
        parsePastedDurations(text) {
            if (!text || typeof text !== 'string') {
                return [];
            }

            const durations = [];
            const lines = text.split(/\r?\n/);

            for (let i = 0; i < lines.length; i++) {
                const line = lines[i].trim();
                if (!line) {
                    continue;
                }

                const firstCell = line.split('\t')[0].trim();
                const normalized = firstCell.replace(',', '.');
                if (!/^-?\d+(\.\d+)?$/.test(normalized)) {
                    continue;
                }

                const value = parseFloat(normalized);
                if (!Number.isFinite(value)) {
                    continue;
                }

                durations.push(normalized);
            }

            return durations;
        },
        isEmptyDuration(value) {
            if (value === null || value === undefined) {
                return true;
            }

            const str = String(value).trim();
            if (!str) {
                return true;
            }

            const num = parseFloat(str.replace(',', '.'));
            return !Number.isFinite(num);
        },
        isPartDurationInvalid(index) {
            return this.showEmptyDurationErrors && this.client_parts[index]
                && this.isEmptyDuration(this.client_parts[index].duration);
        },
        applyPastedDurations() {
            const durations = this.parsePastedDurations(this.pastedDurations);
            if (!durations.length) {
                this.pastedDurationsCount = 0;
                return;
            }

            if (durations.length > this.getVideoCount()) {
                this.template.videos = durations.length;
                this.changeVideoCount(durations.length);
            }

            for (let i = 0; i < durations.length; i++) {
                this.client_parts[i].duration = durations[i];
            }

            this.pastedDurationsCount = durations.length;
            this.showEmptyDurationErrors = false;
        },
        onPasteDurations() {
            this.$nextTick(() => {
                this.applyPastedDurations();
            });
        },
        validatePartDurations() {
            const parts = this.partsForSave();
            const hasEmpty = parts.some((part) => this.isEmptyDuration(part.duration));
            if (!hasEmpty) {
                this.showEmptyDurationErrors = false;
                return true;
            }

            this.showEmptyDurationErrors = true;
            this.$notifications.notify({
                component: {
                    template: '<span><b>Заполните длительность всех фрагментов</b></span>'
                },
                icon: 'nc-icon nc-simple-remove',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'danger'
            });

            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/pastePartDurations.js